import { setupPicoLinkActionsModule } from '../dependencies'

export const { slice, selectors, thunks } = setupPicoLinkActionsModule
export const setupPicoLinkSliceReducer = slice.sliceReducer
export const setupPicoLinkSliceInitialState = slice.sliceInitialState
export default slice.reducer
